// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"MarkdownRender_paragraph__HFcYt","heading":"MarkdownRender_heading__16os1","h1":"MarkdownRender_h1__RutHI"};